var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "sui-table",
        { attrs: { basic: "very", selectable: "", padded: "" } },
        [
          _c(
            "sui-table-header",
            [
              _c(
                "sui-table-row",
                [
                  _c("sui-table-header-cell"),
                  _vm._l(_vm.tableColumns, function (column, index) {
                    return _c("sui-table-header-cell", { key: index }, [
                      _vm._v(" " + _vm._s(column) + " "),
                    ])
                  }),
                  _c("sui-table-header-cell"),
                ],
                2
              ),
            ],
            1
          ),
          _vm.resourceList
            ? _c(
                "sui-table-body",
                _vm._l(_vm.resourceList, function (resource, index) {
                  return _c(
                    "sui-table-row",
                    { key: index },
                    [
                      _c("sui-table-cell", { attrs: { collapsing: "" } }, [
                        _vm._v(_vm._s(index + 1)),
                      ]),
                      _c(
                        "sui-table-cell",
                        [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: resource.assetUrl,
                                target: "_blank",
                              },
                            },
                            [_vm._v(_vm._s(resource.name))]
                          ),
                          _c("font-awesome-icon", {
                            staticStyle: { "margin-left": "8px" },
                            attrs: { icon: "external-link-alt" },
                          }),
                        ],
                        1
                      ),
                      _c("sui-table-cell", [
                        _vm._v(_vm._s(resource.addedDate)),
                      ]),
                      _c("sui-table-cell", [
                        _vm._v(_vm._s(resource.lastModifiedDate)),
                      ]),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }